import UpperGrandLagoonHeroSection from "./components/HeroSection";
import UpperGrandLagoonStickyNav from "./components/StickyNav";
import UpperGrandLagoonProcessingTimeSection from "./components/ProcessingTimeSection";
import UpperGrandLagoonServicesSection from "./components/ServicesSection";
import UpperGrandLagoonLocalAreaSection, { landmarks as upperGrandLagoonLandmarks } from "./components/LocalAreaSection";
import UpperGrandLagoonTestimonialsSection from "./components/TestimonialsSection";
import UpperGrandLagoonAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import UpperGrandLagoonComparisonSection from "./components/ComparisonSection";
import UpperGrandLagoonMistakesSection from "./components/MistakesSection";
import UpperGrandLagoonHowItWorksSection from "./components/HowItWorksSection";
import UpperGrandLagoonFAQSection, { faqs } from "./components/FAQSection";
import UpperGrandLagoonHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import UpperGrandLagoonFinalCTA from "./components/FinalCTA";
import UpperGrandLagoonTravelTimingSection from "./components/TravelTimingSection";
import UpperGrandLagoonDestinationsSection from "./components/DestinationsSection";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

const areaServedList = [
  { "@type": "City", name: "Upper Grand Lagoon" },
  { "@type": "City", name: "Panama City" },
  { "@type": "City", name: "Panama City Beach" },
  { "@type": "City", name: "Lower Grand Lagoon" },
  { "@type": "City", name: "Laguna Beach" },
  { "@type": "City", name: "Lynn Haven" },
  { "@type": "City", name: "Callaway" },
  { "@type": "AdministrativeArea", name: "Bay County" },
];

const serviceAreaDesc = "Fast Passport Center is a registered U.S. Department of State passport courier serving Upper Grand Lagoon, Panama City Beach, Lynn Haven, and Bay County with expedited passport processing as fast as 24 hours. A+ BBB rated.";

export default function UpperGrandLagoonPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Upper Grand Lagoon"
        state="Florida"
        stateAbbr="FL"
        route="/upper-grand-lagoon"
        title="Emergency Passport Upper Grand Lagoon, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Upper Grand Lagoon, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving the Florida Panhandle and Emerald Coast."
        geoPlacename="Upper Grand Lagoon, Florida"
        geoPosition="30.1775;-85.7732"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
        landmarks={upperGrandLagoonLandmarks}
      />
      <UpperGrandLagoonHeroSection />
      <UpperGrandLagoonStickyNav />
      <UpperGrandLagoonLocalAreaSection />
      <UpperGrandLagoonProcessingTimeSection />
      <UpperGrandLagoonServicesSection />
      <UpperGrandLagoonTravelTimingSection />
      <UpperGrandLagoonDestinationsSection />
      <UpperGrandLagoonTestimonialsSection />
      <UpperGrandLagoonAcceptanceFacilitiesSection />
      <UpperGrandLagoonComparisonSection />
      <UpperGrandLagoonMistakesSection />
      <UpperGrandLagoonHowItWorksSection />
      <UpperGrandLagoonFAQSection />
      <UpperGrandLagoonHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/upper-grand-lagoon" state="FL" />
      <UpperGrandLagoonFinalCTA />
    </div>
  );
}